import { loadAuthState } from "../actions/auth";
import { LOGIN_SUCCESS, LOGOUT, PROFILE } from "../constants/auth";

const initialState = {
  ...loadAuthState(),
  id: 0,
  email: "",
  first_name: "",
  last_name: "",
  mobile: "",
  avatar: "",
  user_id: "",
  company_master_account: "",
  is_slack_connected: false,
  is_team_connected: false,
  is_whatsapp_user: false
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case PROFILE:
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT:
      return {
        userName: null,
        token: null,
        isAuthenticated: false,
        expiresAt: null,
      };
    default:
      return state;
  }
};

export default authReducer;
